<template>
  <div>
    <h2 class="content-block">Datagrid Odata Crud</h2>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <DxDataGrid
          id="gridContainer"
          :data-source="dataSource"
          :allow-column-reordering="true"
          :show-borders="true"
          key-expr="ID"
        >
          <DxFilterRow :visible="showFilterRow" :apply-filter="currentFilter" />

          <DxPaging :enabled="true" />
          <DxEditing
            :allow-updating="true"
            :allow-deleting="true"
            :allow-adding="true"
            mode="row"
          />

          <DxColumn
            data-field="id"
            caption="ID"
            sort-order="asc"
            :filter-operations="filterOperations"
          />
          <DxColumn data-field="pegawai_id" caption="Pegawai id" />
          <DxColumn data-field="tgl" caption="Tgl" data-type="date" />
        </DxDataGrid>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>
<script>
import ODataStore from "devextreme/data/odata/store";
import DataSource from "devextreme/data/data_source";

import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPaging,
  DxFilterRow,
} from "devextreme-vue/data-grid";

const dataSource = new DataSource({
  store: new ODataStore({
    // ODataStore is configured here
    url: "http://127.0.0.1/odata/SimpegKgbs",
    key: "id",
    version: 4,
    beforeSend: function (e) {
      e.headers = {
        "odata-version": "4.0",
      };
    },
  }),
  expand: ["pegawai"],
  filter: ["pegawai_id", "=", 19],
});

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxPaging,
    DxFilterRow,
  },
  data() {
    return {
      filterValue: "",
      dataSource,
      editingOptions: {},
      showFilterRow: true,
      currentFilter: [
        {
          key: "auto",
          name: "Immediately",
        },
      ],
      filterOperations: ["=", "<>", ">=", "<=", "month", "year"],
    };
  },
  mounted() {},
};
</script>
